<div *ngIf="titleHeaderVisible" class="cer-flex-static cer-padding-left-8 cer-border-bottom">{{titleHeader}}</div>
<ng-container *ngTemplateOutlet="selectedTemplate; context: { $implicit: view }"></ng-container>
<cer-form-view-type-list [view]="view" #list *ngIf="isList"></cer-form-view-type-list>
<cer-form-view-type-tree [view]="view" #tree *ngIf="isTree"></cer-form-view-type-tree>
<cer-form-view-type-custom [view]="view" #custom *ngIf="isCustom"></cer-form-view-type-custom>
<cer-form-view-type-document [view]="view" #document *ngIf="isDocument"></cer-form-view-type-document>
